import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import styles from './emailCaptureForm.css';
import EmailCloudTeeth from '../../../assets/svg/EmailCloudTeeth';
import EmailCloudMouth from '../../../assets/svg/EmailCloudMouth';

const FORM_STATE = {
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
};

const EmailCaptureForm = ({ subscribeButtonClass }) => {
  const [email, setEmail] = useState('');
  const [formState, setFormState] = useState(FORM_STATE.IDLE);
  const [helpText, setHelpText] = useState('Feed me your email address');

  const handleEmailChange = evt => {
    setEmail(evt.target.value);
  };

  const subscribeEmail = async () => {
    try {
      await axios.post('/.netlify/functions/subscribe', { email: email });
      setHelpText('Mmm, delicious. Thanks!');
      setFormState(FORM_STATE.SUCCESS);
      localStorage.setItem('emailFormState', 'closed');

    } catch (err) {
      const errorTitle = err.response.data.title;
      let errorMsg;

      if (errorTitle === 'Invalid Resource') {
        errorMsg = 'Email is invalid.';
      } else if (errorTitle === 'Member Exists') {
        errorMsg = 'Email already subscribed.';
      } else {
        errorMsg = 'Something went wrong...';
      }

      setHelpText(errorMsg);
      setFormState(FORM_STATE.ERROR);
      console.error(err);
    }
  };

  const handleSubmit = evt => {
    evt.preventDefault();
    subscribeEmail();
  };

  return (
    <form
      onSubmit={handleSubmit}
      method="post"
      id="newsletter-form"
      className={styles.emailForm}
      target="_blank"
      noValidate="">
      <label htmlFor="email">
        {formState === FORM_STATE.SUCCESS ? (
          <div className={styles.cloudMouth}>
            <EmailCloudMouth />
          </div>
        ) : (
          <div className={styles.emailInputWrapper}>
            <div className={styles.cloudTopTeeth}>
              <EmailCloudTeeth />
            </div>
            <input
              id="email-input"
              type="email"
              className={`not-draggable ${styles.emailInput}`}
              name="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="YOUREMAIL@HERE.COM"
              autoComplete="off"
              tabIndex="0"
              required
            />
            <div className={styles.cloudBottomTeeth}>
              <EmailCloudTeeth />
            </div>
          </div>
        )}
        <p className={styles.labelText}>{formState === FORM_STATE.ERROR && '❗️'}{helpText}</p>
      </label>

      {formState !== FORM_STATE.SUCCESS && (
        <input
          id="newsletter-submit"
          type="submit"
          value="SUBSCRIBE"
          name="subscribe"
          className={`not-draggable ${subscribeButtonClass}`}
          tabIndex="0"
        />
      )}
    </form>
  );
};

EmailCaptureForm.propTypes = {
  onSubscribe: PropTypes.func,
  subscribeButtonClass: PropTypes.string,
};

export default EmailCaptureForm;
